module.exports = __webpack_public_path__ + "img/img_aviodPhoney_05.b01780c0.jpg";